const pad2 = (value: string) => String(value || '').padStart(2, '0');

export const toYearMonth = (value: unknown): string => {
  const raw = String(value ?? '').trim();
  const match = raw.match(/^(\d{4})[-/](\d{1,2})(?:[-/]\d{1,2})?$/);
  if (!match) return '';
  return `${match[1]}-${pad2(match[2])}`;
};

export const normalizePastAddressPeriodMonths = (
  periodStartMonth: unknown,
  periodEndMonth: unknown,
  period: unknown,
) => {
  const start = toYearMonth(periodStartMonth);
  const end = toYearMonth(periodEndMonth);
  if (start || end) {
    return { periodStartMonth: start, periodEndMonth: end };
  }

  const raw = String(period ?? '').trim();
  const match = raw.match(/^(\d{4})[-/](\d{1,2})(?:[-/]\d{1,2})?\s*[~～〜]\s*(\d{4})[-/](\d{1,2})(?:[-/]\d{1,2})?$/);
  if (!match) {
    return { periodStartMonth: '', periodEndMonth: '' };
  }

  return {
    periodStartMonth: `${match[1]}-${pad2(match[2])}`,
    periodEndMonth: `${match[3]}-${pad2(match[4])}`,
  };
};

export const formatPastAddressPeriodLabel = (
  periodStartMonth: unknown,
  periodEndMonth: unknown,
  period: unknown,
) => {
  const normalized = normalizePastAddressPeriodMonths(periodStartMonth, periodEndMonth, period);
  if (normalized.periodStartMonth || normalized.periodEndMonth) {
    return `${normalized.periodStartMonth || '—'} ～ ${normalized.periodEndMonth || '—'}`;
  }
  return String(period ?? '').trim();
};
